import type { ComponentType } from 'react';
import type { LandingPageProps } from './landingPageProps';
import LandingPageT05 from './t05-launchdarkly/LandingPage';

/** Labor + lokales `npm run dev` — nicht in Firma-Produktion einbacken. */
export const LANDING_PREVIEWS_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_LANDING_PREVIEWS === 'true';

/** Production default landing on lab (e.g. VITE_LANDING_TEMPLATE=t05). Empty = legacy LandingPage at /. */
export const DEFAULT_LANDING_TEMPLATE_ID = (
  import.meta.env.VITE_LANDING_TEMPLATE as string | undefined
)?.trim() ?? '';

export type LandingTemplateEntry = {
  id: string;
  path: string;
  label: string;
  description: string;
  Component: ComponentType<LandingPageProps>;
};

export const LANDING_TEMPLATES: LandingTemplateEntry[] = [
  {
    id: 't05',
    path: '/preview/landing/t05',
    label: 'Template 05 — LaunchDarkly × Orbis',
    description: 'Refero LaunchDarkly — Neon Control Room, Violet Glow, Pill-Nav, Split-Headline',
    Component: LandingPageT05,
  },
];

export function getDefaultLandingTemplate(): LandingTemplateEntry | null {
  if (!DEFAULT_LANDING_TEMPLATE_ID) return null;
  return LANDING_TEMPLATES.find((t) => t.id === DEFAULT_LANDING_TEMPLATE_ID) ?? null;
}
